$(document).ready(function () {
    $(document).ready(function () {
        function activateMenuItem(hash) {
            $(".menu-item a").removeClass("selected");
            if (hash) {
                const $link = $(`.menu-item a[href="${hash}"]`);
                if (!$link.parent().hasClass("menu-item-has-children")) {
                    $link.addClass("selected");
                }
            }
        }
    
        activateMenuItem(window.location.hash);
    
        $("body").on("click", ".menu-item a", function (e) {
            const href = $(this).attr("href");
            if (href.startsWith("#")) {
                const $link = $(this);
                if (!$link.parent().hasClass("menu-item-has-children")) {
                    activateMenuItem(href);
                    history.replaceState(null, null, href);
                }
            }
        });
    });
    
    $("body").on("click", ".nav-item", function (e) {
        $(".nav-item").toggleClass("open");
        $(".sidebar").toggleClass("open").parent().toggleClass("expanded");
    });
    $("body").on("click", ".menu-mobile .overlay, .btn-close", function (e) {
        $(".nav-item").toggleClass("open");
        $(".sidebar").toggleClass("open").parent().toggleClass("expanded");
    });
    $("body").on("click", ".menu-item", function (e) {
        if (e.target.tagName != "LI") return;
        $(e.currentTarget).toggleClass("open");
    });
    $("body").on("click", "li.menu-item-has-children > a", function (e) {
        e.preventDefault();
        const li = $(this).parent();
        const isTop = li.parent().hasClass("menu");
        if (isTop) {
            $("li.menu-item-has-children.active").not(li).removeClass("active").children("ul.sub-menu").slideUp();
        }
        li.toggleClass("active").children("ul.sub-menu").stop(true, true).slideToggle();
    });
    const header = document.querySelector('.header');
    const scrolled = header.offsetTop;
    window.addEventListener('scroll', () => {
        header.classList.toggle('scrolled', window.scrollY > scrolled);
    });
});